module.exports = __webpack_public_path__ + "img/198.d3625fe9.jpg";